import { Component, Input, Output, OnInit, EventEmitter, Inject } from '@angular/core';
import { IDomain } from '@src/interfaces/domain.interfaces';
import { TranslatePipe } from '@app/shared/pipes/translate.pipe';
import { Store } from '@src/store';

@Component({
    selector: 'domain-configuration',
    template: require('./domain-configuration.component.html'),
    styles: [require('./domain-configuration.component.scss')]
})
export class DomainConfigurationComponent implements OnInit {
    @Input() public domain: IDomain;
    @Output() public testValidate = new EventEmitter<any>();

    public testSuccess: boolean;
    private validations: any[] = [];
    public configurationTestStatus: string = '';
    public isAuthChanged: boolean = false;

    constructor(private store: Store,
                private translatePipe: TranslatePipe,
                @Inject('$scope') private $scope: any) {
        this.$scope.$watch(() => this.domain, (newValue: any, oldValue: any) => {
            if (newValue !== oldValue) {
                this.domain.anonymousAuth = !this.domain.userDN && !this.domain.password;
                this.configurationTestStatus = '';
                this.isAuthChanged = false;
            }
        });
    }

    public ngOnInit() {
        this.validations.push(async () => await this.checkEmpty(this.domain.domainHost, 'ERROR_NO_HOST_NAME'));
        this.validations.push(async () => await this.checkEmpty(this.domain.domainPort, 'ERROR_NO_PORT'));
        this.validations.push(async (anonymous: any) => !anonymous
            ? await this.checkEmpty(this.domain.userDN, 'ERROR_USERNAME_REQUIRED') : '');
        this.validations.push(async (anonymous: any, isAuthChanged: boolean) => !anonymous && isAuthChanged
            ? await this.checkEmpty(this.domain.password, 'ERROR_PASSWORD_RQUEIRED') : ''); 
        this.validations.push(async () => await this.checkEmpty(this.domain.baseDN, 'ERROR_NO_BASEDN'));
    }

    public onAuthAnonymous() {
        if (this.domain.anonymousAuth) {
            this.domain.password = null;
            this.domain.userDN = null;
        }
    }

    public async testDomainConfiguration() {
        this.configurationTestStatus = '';
        this.testSuccess = false;
        const validationResults = [];
        for (const item of this.validations) {
            const result = await item(this.domain.anonymousAuth, this.isAuthChanged);
            if (result) {
                validationResults.push(result);
            }
        }
        if (validationResults.length === 0) {
            this.testSuccess = await this.store.dispatch({
                type: 'TEST_DOMAIN_CONFIGURATION',
                payload: { domainId: this.domain.id, domainData: this.domain }
            });
            this.configurationTestStatus = this.testSuccess ? 'Success' : 'Failed';
        }
        this.testValidate.emit(validationResults);
    }

    private async checkEmpty(field: any, errorMsg: any) {
        if (this.isFieldEmpty(field)) {
            const translations = await this.translatePipe.transform([errorMsg]);
            return translations[errorMsg];
        }
        return null;
    }

    private isFieldEmpty(value: any) {
        return !value || value.toString().trim().length === 0;
    }

    public changeData(): void {
        this.isAuthChanged = true;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/usersRolesManagement/advancedManagement/domain-manager/domain-item/domain-configuration/domain-configuration.component.ts